/* import __COLOCATED_TEMPLATE__ from './draggable-area.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import BLANK_IMAGE from '../../../data/blank-image';
import type Node from '../../../models/graph-editor/node';
import Offset from '../../../models/graph-editor/offset';
import Coordinates from '../../../models/graph-editor/coordinates';

interface Args {
  node: Node;
}
export default class GraphEditorNodeDraggableAreaComponent extends Component<Args> {
  blankDragImage: HTMLImageElement = new Image(1, 1);
  constructor(owner: unknown, args: Args) {
    super(owner, args);
    this.args = args;
    this.blankDragImage.src = BLANK_IMAGE;
  }

  @action onDragStart(event: DragEvent): void {
    // Firefox requires data to be set for the element to start dragging
    event.dataTransfer?.setData('text/plain', '');

    // Set the data image to be blank so the browser doesn't default
    // to the 'ghost image' effect while dragging.
    event.dataTransfer?.setDragImage(this.blankDragImage, 1, 1);

    // If we cannot select the node, return immediately.
    if (!this.args.node.graph.hooks.canSelectNode(this.args.node)) {
      return;
    }

    // Set a reference to the dragging node
    this.args.node.graph.state.draggingNode = this.args.node;

    // Set the cursor offset, this allows us to keep the element 'snapped' in the right position
    this.args.node.graph.state.cursorOffset = new Offset(event.offsetX, event.offsetY);

    // Capture what the initial the positioning coordinates are.
    // We will move all selected nodes relative to this point.
    this.args.node.graph.state.positioningCoordinates = Coordinates.scaledAndRounded(
      event.clientX,
      event.clientY,
      this.args.node.graph,
    );

    // Dragging automatically selects the node
    this.args.node.graph.state.addSelectedNode(this.args.node);

    this.args.node.graph.startTrackingActions();
  }

  @action onDragEnd(_: DragEvent): void {
    this.args.node.graph.stopTrackingActions();
    this.args.node.graph.state.draggingNode = undefined;
  }
}
